import { render } from "./SelectPlan.vue?vue&type=template&id=deff3af8&scoped=true&ts=true"
import script from "./SelectPlan.vue?vue&type=script&lang=ts"
export * from "./SelectPlan.vue?vue&type=script&lang=ts"

import "./SelectPlan.vue?vue&type=style&index=0&id=deff3af8&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deff3af8"]])

export default __exports__